interface WrennenLogoMarkProps {
  size?: number;
  className?: string;
}

const WrennenLogoMark = (props: WrennenLogoMarkProps) => {
  const { size = 20, className = '' } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M4.2 4.5H6.45L8.65 16.72L11.1 4.5H12.95L15.38 16.72L17.58 4.5H19.8L16.68 19.5H14.35L12 8.43L9.65 19.5H7.32L4.2 4.5Z"
        fill="currentColor"
      />
      <path d="M7.1 19.5H16.9" stroke="currentColor" strokeWidth="0.95" strokeLinecap="square" opacity="0.28" />
    </svg>
  );
};

export default WrennenLogoMark;
